/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { APP_COLORS } from "../../../common/Constants";
import { CompanyDetailText } from "../Company";
import { faMinus, faPlus } from "@fortawesome/pro-solid-svg-icons";

const CompanyHeader = (props) => {
    const {
        title,
        titleSize = 20,
        seeAll = false,
        showMore = false,
        onSeeAll,
        onShowMore,
        more = false,
        disabled = false,
    } = props;

    const actionColor = disabled ? '#CCC' : APP_COLORS.primary;

    return (
        <>
            <Row>
                <Col xs={6}>
                    <CompanyDetailText fontWeight={'bold'} fontSize={titleSize}>{title}</CompanyDetailText>
                </Col>
                <Col xs={6} style={{ textAlign: 'right'}}>
                    {(seeAll && !showMore) && (
                        <div
                            style={{ cursor: 'pointer', alignContent: 'center' }}
                            onClick={() => console.log('seeAll')}
                        >
                            <CompanyDetailText
                                fontWeight={'bold'}
                                fontSize={15}
                                color={actionColor}
                            >See All {'>>'}</CompanyDetailText>
                        </div>
                    )}
                    {(showMore && !seeAll) && (
                        <div
                            style={{ cursor: 'pointer', alignContent: 'center' }}
                            onClick={() => {
                                if (more) {
                                    onShowMore(false);
                                } else {
                                    onShowMore(true)
                                }
                            }}
                        >
                            { more ? (
                                <CompanyDetailText
                                    fontWeight={'bold'}
                                    fontSize={15}
                                    color={actionColor}
                                >
                                    Show Less
                                    <FontAwesomeIcon
                                        style={{marginLeft: '10px'}}
                                        color={actionColor}
                                        icon={faMinus}
                                    />
                                </CompanyDetailText>
                            ) : (
                                <CompanyDetailText
                                    fontWeight={'bold'}
                                    fontSize={15}
                                    color={actionColor}
                                >
                                    Show More
                                    <FontAwesomeIcon
                                        style={{marginLeft: '10px'}}
                                        color={actionColor}
                                        icon={faPlus}
                                    />
                                </CompanyDetailText>
                            )}
                        </div>
                    )}
                </Col>
            </Row>
        </>
    )
}

export default CompanyHeader;
